import { Descriptions} from "antd";
import { useLoaderData, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

// @ts-ignore
import {get, startCase} from 'lodash';



export default function ViewUserData() {
    const device: any = useLoaderData();
    
    let navigate = useNavigate();
    
    const [items, setItems] = useState([]);
    
    useEffect(()=>{
        if (device) {
            const data:any = get(device, 'data.data', {});

            let item: any = Object.keys(data).map((k:any)=>({
                key: k,
                label: startCase(k),
                children: data[k]
            }))

            setItems(item);
        }
    });


    return (<Descriptions title="Device Data" items={items} />);
        
}